/* src/app/order/components/history/order-changes/order-changes.style.scss */
.history-collapsed-header {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #cccccc !important;
}
.history-collapsed-header .status-box {
  max-width: 70px;
  border-radius: 16px;
  text-align: center;
  font-size: 10px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  line-height: 1.1;
  letter-spacing: 0.55px;
  color: #ffffff;
  padding: 5px 10px;
  margin-right: 5px;
  margin-top: 1px;
}
.history-collapsed-header .status-box.active {
  background-color: #007d40;
}
.history-collapsed-header .status-box.declined {
  background-color: red;
}
.history-collapsed-header .status-box.inactive {
  background-color: #ee7f00;
}
.history-collapsed-header .status-box.deletion {
  background-color: red;
  max-width: 110px;
}
.history-collapsed-header .toggle-order-collapse {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
}
.history-collapsed-header .toggle-order-collapse nb-icon {
  position: relative;
  top: 2px;
}
h4 {
  font-family: Arial, sans-serif;
  font-size: 26px;
  font-weight: bold;
  line-height: 1.23;
  color: #585858;
  margin-top: 10px;
  margin-bottom: 0;
}
.order-number {
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.85;
  color: #585858;
  margin-bottom: 10px;
}
.created-when {
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
.timestamp {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #585858;
}
nb-card-body {
  padding-top: 0 !important;
}
/*# sourceMappingURL=order-changes.style.css.map */
